<template>
  <v-app>
    <v-container>
      <v-card
        ><v-card-title> {{ title }}</v-card-title>

        <v-card-text>
          <v-data-table :headers="headers" :items="items">
            <template v-slot:item.sumPoint="{ item }">
              {{ item.sumPoint | numFormat("0,000,000") }}
            </template>
            <template v-slot:item.sumAmount="{ item }">
              {{ item.sumAmount | numFormat("0,000,000") }}
            </template></v-data-table
          ></v-card-text
        >
      </v-card>
    </v-container></v-app
  >
</template>
<script>
import axios from "axios";
export default {
  name: "memberReport",
  data() {
    return {
      items: [],
      title: "ยอดสั่งซื้อสูงสุดตามรายชื่อสมาชิก",
      start: "",
      end: "",
      start_date: new Date(new Date().setDate(new Date().getDate() - 30))
        .toISOString()
        .slice(0, 10), //new Date().toISOString().slice(0,10),//.replace(/-/g,""),
      end_date: new Date().toISOString().slice(0, 10), //.replace(/-/g,""),
      headers: [
        { text: "สมาชิก", value: "fullname" },
        { text: "ยอดซื้อ", value: "sumAmount" },
        { text: "คะแนน", value: "sumPoint" },
        { text: "จำนวนครั้ง", value: "cntSale" },
      ],
    };
  },
  mounted() {
    //console.log("memberReport");
    this.init();
  },
  methods: {
    async init() {
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        //
        let payloadBody = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          start: this.start_date,
          end: this.end_date,
        };
        axios
          .post(
            url + "/v1/report/top-spender",
            payloadBody // need to change
          )
          .then((response) => {
            //console.log(response.data.data);
            this.items = response.data.data.map((item) => {
              return {
                fullname: item._id.firstname + " " + item._id.lastname,
                sumAmount: item.sumAmount,
                sumPoint: item.sumPoint,
                cntSale: item.cntSale,
              };
            });
            //console.log(this.items);
          });
      } catch (e) {
        //console.log(e);
      }
    },
  },
};
</script>
